<template>
    <div class="box">
        <div class="box-content">
            <table class="table _lined">
                <thead>
                <tr>
                    <th>
                        Name
                    </th>
                    <th></th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                    <tr v-if="new_category">
                        <td>
                            <input type="text" v-model="new_category.label" class="form-control" placeholder="New Category Name">
                        </td>
                        <td style="width: 30px;">
                        </td>
                        <td @click="createCategory()" style="width: 30px;" class="cursor-pointer">
                            <i class="fal fa-save"></i>
                        </td>
                    </tr>
                    <tr v-for="category in categories" v-if="editing.id !== category.id">
                        <td>
                            <input type="text" v-model="category.label" class="form-control _stealth" readonly>
                        </td>
                        <td class="txt-danger cursor-pointer" style="width: 30px;" @click="deleteCategory(category.id)">
                            <i class="fal fa-trash-alt"></i>
                        </td>
                        <td @click="editing = category" style="width: 30px;" class="cursor-pointer">
                            <i class="fal fa-pencil"></i>
                        </td>
                    </tr>
                    <tr v-else>
                        <td class="w-full">
                            <input type="text" v-model="editing.label" class="form-control">
                        </td>
                        <td style="width: 30px;" class="cursor-pointer">
                            <i class="fal fa-times" @click="editing = {}"></i>
                        </td>
                        <td @click="updateCategory()" style="width: 30px;" class="cursor-pointer">
                            <i class="fal fa-save"></i>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            'categories': [],
            'editing': {},
            'new_category': {
            },
            'loading': true,
        };
    },
    mounted() {
        this.loadCategories();
    },
    methods: {
        loadCategories() {
            axios.get('/news/getCategories').then((response) => {
                this.categories = response.data;
                this.loading = false;
            });
        },
        updateCategory() {
            this.loading = true;
            axios.post('/news/updateCategory', {
                'id': this.editing.id,
                'label': this.editing.label,
                'sort_order': this.editing.sort_order,
            }).then(() => {
                this.editing = {};
                this.loadCategories();
                this.loading = false;
            });
        },
        createCategory() {
            this.loading = true;
            axios.post('/news/createCategory', {
                'label': this.new_category.label,
                'sort_order': this.new_category.sort_order,
            }).then(() => {
                this.new_category = {};
                this.loadCategories();
                this.loading = false;
            });
        },
        deleteCategory(category_id) {
            this.loading = true;

            Swal.fire({
                title: 'Are you sure you want to remove this category?',
                text: 'This action cannot be undone.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Confirm',
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.post('/news/deleteCategory', {
                        'category_id': category_id,
                    }).then((response) => {
                        if(response.data.deleted) {
                            this.loadCategories();
                            this.loading = false;
                        } else {
                            Swal.fire({
                                'title': 'Category not deleted',
                                'icon': 'warning',
                                'html': response.data.message,
                            });
                        }
                    });
                }
            });
        },
    },
};
</script>
